export const baseUrl = "https://api.themoviedb.org/3/movie/";

export const apiKey = "1e2f4ae9cf56f3e1c8367fb458677972" ;

export const colorPrimario = "#383B53";

export const colorSecundario= "#FEF5EC";

export const colorTerciario="#4A4E6D)";

export const colorTipografiaPrimario = "#ffffff";

export const tipografiaPrincipal='Lexend Deca';